export default __webpack_public_path__ + "static/media/unique.f09ae7e4.svg";